module.exports = __webpack_public_path__ + "static/media/galeryGrass7.50f5ad37.jpg";